// removed by extract-text-webpack-plugin
module.exports = {"picker":"eOdxoVafslpnkQ6EmY-hg","pick":"_3rpYHEZrRM15t3GDxgGWxj"};


//////////////////
// WEBPACK FOOTER
// ./app/components/CustomerPicker/style.scss
// module id = 1064
// module chunks = 0